module.exports = __webpack_public_path__ + "images/emails/logo-with-name-f6887bf333c81ab84759fd56dce3dbae.png";